export default {
    faq:{
        en:'FAQ',
        tc:'常問問題',
        sc:'常问问题'
    },
    aboutThis:{
        en:'About This Hotel',
        tc:'關於酒店',
        sc:'关于酒店'
    },
    aboutServices:{
        en:'About services and facilities',
        tc:'關於服務和設施',
        sc:'关于服务和设施',
    },
    q1:{
        en:'How do I make a hotel booking?',
        tc:'如何預訂酒店？',
        sc:'如何预订酒店？'
    },
    q1_a:{
        en:'Please do so through this website.',
        tc:'辦理入住時，住宿費用將從您預訂時使用的信用卡中扣除。',
        sc:'请通过本网站进行预订。',
    },
    q2:{
        en:'How do I pay for the accommodation?',
        tc:'如何支付住宿費用？',
        sc:'如何支付住宿费用？'
    },
    q2_a:{
        en:'Upon checking-in, accommodation fees will be charged to the credit card used when you made your booking with us.',
        tc:'辦理入住時，住宿費用將從您預訂時使用的信用卡中扣除。',
        sc:'办理入住时，住宿费用将从您预订时使用的信用卡中扣除。'
    },
    q3:{
        en:'When will cancellation fees apply?',
        tc:'什麼情況下會收取取消費用？',
        sc:'什么情况下会收取取消费用？'
    },
    q3_a:{
        en:'Cancellation Fees will be charged on the following occasions:\nCancellation made:\nOn the Day or No Show - 100%\n1 Day Prior - 80%\n2 Days Prior - 50%\n3 Days Prior - 30%',
        tc:'在以下情況下將收取取消費用：\n取消時間：\n當天或未現身 - 100%\n提前1天 - 80%\n提前2天 - 50%\n提前3天 - 30%',
        sc:'在以下情况下将收取取消费用：\n取消时间：\n当天或未现身 - 100%\n提前1天 - 80%\n提前2天 - 50%\n提前3天 - 30%'
    },
    q4:{
        en:'What are the facilities in the common area?',
        tc:'公共區域有哪些設施？',
        sc:'公共区域有哪些设施？'
    },
    q4_a:{
        en:'In the common area we have a coin laundry, fridge, microwave and a water dispenser.',
        tc:'在公共區域，我們設有投幣式自助販賣機、冰箱、微波爐和飲水機。',
        sc:'在公共区域，我们设有投币式自助贩卖机、冰箱、微波炉和饮水机。'
    },
    q5:{
        en:'What bathing amenities are provided?',
        tc:'酒店提供哪些沐浴用品？',
        sc:'酒店提供哪些沐浴用品？'
    },
    q5_a:{
        en:'We include free shampoo/ conditioner/ shower gel for hotel guest.',
        tc:'我們為酒店客人提供免費洗髮水、護髮素和沐浴露。',
        sc:'我们为酒店客人提供免费洗发水、护发素和沐浴露。'
    },
    q6:{
        en:'Is there Wi-Fi?',
        tc:'酒店有免費Wi-Fi嗎？',
        sc:'酒店有免费Wi-Fi吗？'
    },
    q6_a:{
        en:'Yes. We have Wi-Fi throughout the building.',
        tc:'我們整棟建築範圍内都提供免費Wi-Fi服務。',
        sc:'我们整栋建筑范围内都提供免费Wi-Fi服务。'
    },
    q7:{
        en:'Are there rental computers?',
        tc:'酒店有提供出租電腦嗎？',
        sc:'酒店有提供出租电脑吗？'
    },
    q7_a:{
        en:'No. We do not rent out computers.',
        tc:'沒有。我們並不提供電腦出租服務。',
        sc:'没有。我们并不提供电脑出租服务。'
    },
    q8:{
        en:'Can I send my luggage to the hotel ahead of arrival?',
        tc:'我可以提前寄送行李到酒店嗎？',
        sc:'我可以提前寄送行李到酒店吗？'
    },
    q8_a:{
        en:'Yes. When doing so please send by pre-pay and write your booking name, arrival date and contact information.',
        tc:'可以。寄送時請提早聯絡我們，並註明您的預訂姓名、到達日期和聯繫方式。',
        sc:'可以。寄送时请提早联络我们，并注明您的预订姓名、到达日期和联系方式。'
    },
    q9:{
        en:'Are the rooms cleaned daily during my stay?',
        tc:'我住宿期間房間會每天打掃嗎？',
        sc:'我住宿期间房间会每天打扫吗？'
    },
    q9_a:{
        en:'Rooms will be cleaned upon request.',
        tc:'房間將根據嚴格衛生要求每天進行清潔。',
        sc:'房间将根据严格卫生要求每天进行清洁。'
    },
    q10:{
        en:'Are drinking water provided?',
        tc:'酒店提供飲用水嗎？',
        sc:'酒店提供饮用水吗？'
    },
    q10_a:{
        en:'Filtered drinking water located on the 5/F podium area, each room cotain a glass vessel for collection of water on the 5/F.',
        tc:'5樓平台區提供過濾飲用水，每間房間都配有一個玻璃容器以便在5樓收集飲用水。',
        sc:'5楼平台区提供过滤饮用水，每间房间都配有一个玻璃容器以便在5楼收集饮用水。'
    },
    q11:{
        en:'Are there any smoking / common areas?',
        tc:'酒店有吸煙區 / 休息區嗎？',
        sc:'酒店有吸烟区 / 休息區吗？'
    },
    q11_a:{
        en:'5/F prodium area destinated for smoking/ chill out / vending machines.',
        tc:'5樓平台區域設有吸煙區、休息區和自動售貨機。',
        sc:'5楼平台区域设有吸烟区、休息区和自动售货机。'
    },
}